// The papers behind ?chocobo: one per month, each a different regional paper of
// Ivalice with its own reporter. A new month gets a new paper and a new reporter,
// so a back issue doesn't need to know about anything written after it.
//
// `load`/`stats` are lazy so a month's issues and numbers only download when that
// month is read. The reporter's favorite class gets its own line in the sidebar
// (rolls and titles that day, from stats-<month>.json's per-class tally), so pick a
// class name exactly as the tournament data spells it ("Time Mage", "Red Chocobo").
// `gender` picks the portrait: 'M' / 'F' for jobs, 'X' for monsters.
//
// Newest first.

export const PAPERS = [
  {
    month: '2026-11',
    name: 'The Gariland Gazer',
    region: 'Gariland',
    motto: 'Watching chat so you don\'t have to',
    price: 'One glance',
    reporter: {
      name: 'Iris Vigil',
      cls: 'Floating Eye',
      gender: 'X',
      sign: 'Sagittarius',
      bio: 'Iris Vigil joined the Gazer the morning after Halloween, and is new to journalism and to Gariland. Iris does not remember arriving, has never eaten a Gysahl Green, and dislikes fences for reasons it cannot explain. Iris covers the Floating Eye beat, which has a great deal of rolling and very little winning. Interests: watching, filing, not being asked about birds.',
    },
    load: () => import('./2026-11.js'),
    stats: () => import('./stats-2026-11.json'),
  },
  {
    month: '2026-10',
    name: 'The Daily Chocobo',
    region: 'Mandalia Plains',
    motto: "All the chat that's fit to print",
    price: 'Free (unlike Smobot)',
    reporter: {
      name: 'Wark Twain',
      cls: 'Chocobo',
      gender: 'X',
      sign: 'Sagittarius',
      bio: 'Wark Twain has covered the Arena since he was a chick. He files from a nest on the Mandalia Plains, reports every Chocobo result with the bias you would expect, and has never forgiven the Red Chocobo branch of the family for being better at it. Interests: running, Gysahl Greens, not being turned into a frog.',
    },
    load: () => import('./2026-10.js'),
    stats: () => import('./stats-2026-10.json'),
  },
];
